import { useInfiniteQuery } from '@tanstack/react-query';

import { TPageReviewUiEventDto, useAvApi } from '@app-velocity/av-api-v2';

export const useGetEventsForScenario = (
  workspaceId?: string,
  scenarioId?: string
) => {
  const { prototypes } = useAvApi();

  const data = useInfiniteQuery({
    queryKey: ['scenario-events', workspaceId, scenarioId],
    enabled: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 0,
    gcTime: 0,
    queryFn: async ({ pageParam }) => {
      if (!scenarioId || !workspaceId) throw new Error();
      const data =
        await prototypes.getV2ProjectsPrototypesReviewsEventsByProjectIdAndPrototypeId(
          { projectId: workspaceId, prototypeId: scenarioId },
          {
            eventTypes: ['CLICK'],
            pageable: {
              size: 200,
              page: pageParam,
            },
          }
        );

      return data.data;
    },
    getNextPageParam: (lastPage: TPageReviewUiEventDto) => {
      if ((lastPage.number || 0) + 1 < (lastPage.totalPages || 0)) {
        return (lastPage.number || 0) + 1;
      }

      return undefined;
    },
    initialPageParam: 0,
  });

  return data;
};
